import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { H6, Small } from "@/components/standard/BFText"
import Svg, { Path } from "react-native-svg"

function CalcIcon() {
  return (
    <Svg width={14} height={16} viewBox="0 0 14 16" fill="none">
      <Path
        d="M3.973 8.293L9.768 6.74a.5.5 0 00.354-.612L9.345 3.23a.5.5 0 00-.612-.354L2.937 4.43a.5.5 0 00-.353.613l.776 2.897a.5.5 0 00.613.354zm-.294-3.027l4.83-1.294.517 1.932-4.83 1.294-.517-1.932zM9.664.556L.971 2.886A1 1 0 00.264 4.11L3.11 14.736a1 1 0 001.224.707l8.694-2.33a1 1 0 00.707-1.224L10.889 1.263A1 1 0 009.664.556zm3.106 11.591l-8.693 2.33L1.23 3.852l8.693-2.33 2.847 10.626zM5.633 9.66a.75.75 0 11-1.45.388.75.75 0 011.45-.388zm2.415-.647a.75.75 0 11-1.45.388.75.75 0 011.45-.388zm2.415-.647a.75.75 0 11-1.449.388.75.75 0 011.449-.388zM6.28 12.075a.75.75 0 11-1.449.388.75.75 0 011.449-.388zm2.415-.647a.75.75 0 11-1.448.388.75.75 0 011.448-.388zm2.415-.647a.75.75 0 11-1.449.388.75.75 0 011.449-.388z"
        fill="#121F3A"
      />
    </Svg>
  )
}

export function LoanDetailsDisclaimer() {
  return (
    <Horizontal
      className={"bg-teal rounded p-3 border-midnight-blue border flex-1 gap-3"}
    >
      <CalcIcon />
      <Vertical className={"flex-1"}>
        <H6 color={"default"}>
          NOTE: The information provided is an estimation
        </H6>
        <Small>
          If you choose to apply, a Backflip loan expert will contact you to
          review associated costs before finalizing.
        </Small>
      </Vertical>
    </Horizontal>
  )
}
